import type { CSSProperties, FC, ReactNode } from 'react'

import { Blob } from '@/components/generals/blob'

const COLORS = ['text-butter', 'text-bubblegum', 'text-mint', 'text-lavender', 'text-coral', 'text-sky']
const PIECES = 24

// A one-off burst of little stickers. Render it only after an event
// (it is never server-rendered), and remount it to fire again.
export const Confetti: FC = (): ReactNode => {
    return (
        <div aria-hidden='true' className='pointer-events-none absolute top-1/3 left-1/2 z-20'>
            {Array.from({ length: PIECES }, (_, index) => {
                const angle = (index / PIECES) * Math.PI * 2
                const distance = 110 + (index % 3) * 55
                const style = {
                    '--cx': `${Math.round(Math.cos(angle) * distance)}px`,
                    '--cy': `${Math.round(Math.sin(angle) * distance)}px`,
                    '--cr': `${(index % 2 === 0 ? 1 : -1) * (180 + index * 15)}deg`,
                    animationDelay: `${(index % 4) * 40}ms`
                } as CSSProperties

                return (
                    <Blob
                        key={index}
                        shape={index % 3 === 0 ? 'burst' : index % 3 === 1 ? 'flower' : 'blob'}
                        className={`absolute -top-2 -left-2 size-4 animate-confetti ${COLORS[index % COLORS.length]}`}
                        style={style}
                    />
                )
            })}
        </div>
    )
}
